/** @file Premultiplies rgb by alpha (rounding to nearest) into a new image for renderer texture caches. */
import type { RgbaImage } from '@pose2d/math/types';
import { invariant } from '@pose2d/std/invariant';

/** Returns a premultiplied copy; input must be straight alpha. */
export function premultiply(image: RgbaImage): RgbaImage {
  invariant(!image.premultiplied, 'premultiply: image is already premultiplied');
  const src = image.data;
  const out = new Uint8ClampedArray(src.length);
  for (let i = 0; i < src.length; i += 4) {
    const a = src[i + 3] ?? 0;
    // round(c * a / 255) exactly, for every c, a in 0..255 (Blinn's integer form).
    for (let k = 0; k < 3; k++) {
      const t = (src[i + k] ?? 0) * a + 128;
      out[i + k] = (t + (t >> 8)) >> 8;
    }
    out[i + 3] = a;
  }
  return { width: image.width, height: image.height, data: out, premultiplied: true };
}
